import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { connect } from 'react-redux';
import { injectIntl, FormattedMessage } from 'react-intl';
import { Button, ButtonGroup, Col, Dropdown, DropdownButton, Form, InputGroup, Row } from 'react-bootstrap';

import { editAddressRequest, getCountryNameTranslation } from '../../AddressActions.js';
import { editUserRequest, getLoggedUser } from '../../../User/UserActions.js';
import { getLanguagePath } from '../../../Intl/IntlHelper.js';
import { displayErrors } from '../../../Error/ErrorActions.js';

import withRouter from '../../../../components/Router/WithRouter.js';
import Icon from '../../../../components/Content/Icon.js';
import Flag from '../../../../components/Flag/Flag.js';
import CountrySelector from './CountrySelector.js';

class AddressEditForm extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isInitiated: false,
            address: props.address ? props.address : {},
			countryData: null,
			countries: [],
            callingCode: '',
            errorFields: [],
            isSaving: false,
        };
    }

    componentDidUpdate(prevProps, prevState) {
        if(!prevProps.address && this.props.address) {
            this.init();
        }
    }

    init = () => {
        const callingCode = this.getCallingCode();
        this.setState({
            isInitiated: true,
            address: {
                ...(this.props.address || {}),
                ...this.state.address,
                // name: '', // `${this.props.user.firstName || ''} ${this.props.user.lastName || ''}`
                // country: (((this.state.countries || []).find(country => country.cca2.toLowerCase().trim() === ((this.props.address || {}).countryCode || '').toLowerCase()) || {}).name || {}).common || (countryDataFromLocale && countryDataFromLocale.name.common) || '',
                phone: (this.state.address || {}).phone || (this.props.address || {}).phone || (this.props.user || {}).phone || '',
            },
            callingCode,
        });
    };

    getAvailableCallingCodes = (withData = false) => {
        return (this.state.countries || [])
            .map(country => {
                const callingCode = this.getCallingCodeFromCountry(country);
                return withData ? { ...country, callingCode } : callingCode;
            })
            .filter(data => data)
            .sort((dataA, dataB) => ((withData ? dataA.callingCode : dataA) || '').localeCompare((withData ? dataB.callingCode : dataB) || ''));
    };

    getCallingCode = () => {
        return this.getCallingCodeFromPhone((this.state.address || {}).phone || (this.props.address || {}).phone || '')
            || this.state.callingCode
            || this.getCallingCodeFromCountry(this.state.countryData || {})
            || '';
    };

    getCallingCodeFromCountry = country => {
        if(country && country.idd) {
            return `${country.idd.root.replace('+', '')}${(country.idd.suffixes || [])[0]}`;
        }
        return null;
    };

    getCallingCodeFromPhone = phone => {
        if(phone && phone.includes('+')) {
            return this.getAvailableCallingCodes().find(callingCode => callingCode === phone.substring(1, callingCode.length + 1));
        }
        return '';
    };

    isValid = () => {
        return this.state.address.name && this.state.address.street1 && this.state.address.postalCode && this.state.address.city && this.state.address.country && (this.props.hidePhone || this.state.address.phone);
    };

    handleChange = event => {
		if(event) {
			const { target } = event;
			const value = target.type === 'checkbox' ? target?.checked : target?.value;
			const { name } = target;

			let { callingCode } = this.state;
			if(name === 'phone') {
				callingCode = this.getCallingCodeFromPhone(value) || callingCode;
			}

			this.setState({
				address: {
					...this.state.address,
					[name]: value,
				},
				callingCode,
			});
		}
    };

	handleChangeLegal = (event, indexToEdit) => {
		if(event) {
			this.setState({
				address: {
					...this.state.address,
					legal: this.state.address.legal.map((legal, index) => {
						if(index === indexToEdit) {
							return {
								...legal,
								[event.target?.name]: event.target?.value,
							};
						}
						return legal;
					}),
				},
			});
		}
	};

	handleAddLegal = () => {
		this.setState({
			address: {
				...this.state.address,
				legal: [
					...(this.state.address.legal || []),
					{
						key: '',
						value: '',
					},
				],
			},
		});
	};

	handleRemoveLegal = indexToRemove => {
		this.setState({
			address: {
				...this.state.address,
				legal: this.state.address.legal.filter((legal, index) => index !== indexToRemove),
			},
		});
	};

    handleSelectCountry = selected => {
		if(selected) {
			this.setState({
				address: {
					...this.state.address,
					country: getCountryNameTranslation(selected, this.props.intl.locale),
				},
				countryData: selected,
				callingCode: this.getCallingCodeFromCountry(selected || {}) || this.state.callingCode || '',
			});
		}
    };

    handleSubmit = event => {
        event.preventDefault();

        if(this.isValid()) {
            if((this.state.countryData || (this.state.address?.country && this.state.address?.countryCode)) || this.props.user?.role === 'admin') { // Handle custom country set by admin
                this.setState({
                    isSaving: true,
                });

                let phone = ((this.state.address || {}).phone || '').replace(this.state.callingCode ? `+${this.state.callingCode}` : '', '').trim();
                if(phone) {
                    phone = `${this.state.callingCode ? `+${this.state.callingCode}` : ''}${phone[0] === '0' ? phone.substring(1) : phone}`;
                }

                const newAddress = {
                    ...this.state.address,
                    user: this.state.address.user || this.props.user?._id,
                    label: this.state.address.label || this.state.address.name,
                    countryCode: (this.state.countryData ? this.state.countryData.cca2 : this.state.address?.countryCode) || this.state.address?.country,
                    country: this.state.countryData ? getCountryNameTranslation(this.state.countryData, this.props.intl.locale) : this.state.address?.country,
                    phone,
                    isUsedForInvoice: this.state.address.isUsedForInvoice || !(this.props.addresses && this.props.addresses.length > 0),
                };

                if(this.props.user && !this.props.skipSave) {
                    this.props.dispatch(editAddressRequest(newAddress)).then(address => {
                        this.setState({
                            isSaving: false,
                        });
                        if(address) {
                            this.setState({
                                address,
                            });
                            displayErrors('success', this.props.intl.formatMessage({
                                id: 'addressSavedSuccess',
                                defaultMessage: 'Address saved!',
                            }));
                            // If address name contains user's firstname and user's lastname not already set => Update user's lastname
                            if(!this.props.user.lastName && address.name.includes(this.props.user.firstName)) {
                                this.props.dispatch(editUserRequest({
                                    ...this.props.user,
                                    lastName: address.name.replace(this.props.user.firstName, '').trim(),
                                    phone: this.props.user.phone || phone,
                                }, true));
                            }
                            this.closeForm(address);
                        }
                    });
                } else {
					this.setState({
						isSaving: false,
                    });
                    this.closeForm(newAddress);
                }
            } else {
                displayErrors('warning', this.props.intl.formatMessage({
                    id: 'alertCountryNotFoundError',
                    defaultMessage: 'Please select a country in the list!',
                }));
            }
        } else {
            this.setState({
                errorFields: ['name', 'street1', 'postalCode', 'city', 'country', !this.props.hidePhone && 'phone'].filter(key => key && !this.state.address[key]),
            });
            displayErrors('error', this.props.intl.formatMessage({
                id: 'alertFormRequiredFieldsError',
                defaultMessage: 'Please fill all required fields!',
            }));
        }
    };

    closeForm = address => {
        if(this.props.closeForm) {
            this.props.closeForm(address);
        } else {
            this.props.navigate(getLanguagePath('/addresses', this.props.intl.locale));
        }
    };

    hasErrorField(name) {
        return this.state.errorFields && this.state.errorFields.indexOf(name) !== -1;
    }

    render() {
        return (
            <Form onSubmit={this.handleSubmit}>
                {
                    this.props.displayLabel
                    ? <Form.Group className="me-2 mb-2">
                        <Form.Control type="text" name="label" value={this.state.address.label} placeholder={this.props.intl.formatMessage({ id: 'addressLabel', defaultMessage: 'Label (ex: My home)' })} onChange={this.handleChange} />
                      </Form.Group>
                    : null
                }
                <Form.Group className={classnames('me-2', 'mb-2', this.hasErrorField('name') ? 'has-danger' : '')}>
                    <Form.Control type="text" name="name" value={this.state.address.name} className={this.hasErrorField('name') ? 'is-invalid form-control-danger' : ''} placeholder={this.props.intl.formatMessage({ id: 'addressName', defaultMessage: 'First name and last name' })} onChange={this.handleChange} />
                </Form.Group>
                <Form.Group className={classnames('me-2', 'mb-2', this.hasErrorField('street1') ? 'has-danger' : '')}>
                    <Form.Control type="text" name="street1" value={this.state.address.street1} className={this.hasErrorField('street1') ? 'is-invalid form-control-danger' : ''} placeholder={this.props.intl.formatMessage({ id: 'addressStreet1', defaultMessage: 'Address' })} onChange={this.handleChange} />
                </Form.Group>
                <Form.Group className="me-2 mb-2">
                    <Form.Control type="text" name="street2" value={this.state.address.street2} placeholder={this.props.intl.formatMessage({ id: 'addressStreet2', defaultMessage: 'Apartment number, digital code, intercom, ...' })} onChange={this.handleChange} />
                </Form.Group>
                <Row className="g-0">
                    <Col>
                        <Form.Group className={classnames('me-2', 'mb-2', this.hasErrorField('postalCode') ? 'has-danger' : '')}>
                            <Form.Control type="text" name="postalCode" value={this.state.address.postalCode} className={this.hasErrorField('postalCode') ? 'is-invalid form-control-danger' : ''} placeholder={this.props.intl.formatMessage({ id: 'addressPostalCode', defaultMessage: 'Postal code' })} onChange={this.handleChange} />
                        </Form.Group>
                    </Col>
                    <Col>
                        <Form.Group className={classnames('me-2', 'mb-2', this.hasErrorField('city') ? 'has-danger' : '')}>
                            <Form.Control type="text" name="city" value={this.state.address.city} className={this.hasErrorField('city') ? 'is-invalid form-control-danger' : ''} placeholder={this.props.intl.formatMessage({ id: 'addressCity', defaultMessage: 'City' })} onChange={this.handleChange} />
                        </Form.Group>
                    </Col>
                </Row>
                <Form.Group className={classnames('me-2', 'mb-2', this.hasErrorField('country') ? 'has-danger' : '')}>
                    <CountrySelector
						country={this.state.address?.country}
						onSelect={this.handleSelectCountry}
						onFetch={countries => this.setState({ countries })}
						inputProps={{ name: 'country', className: classnames('form-control', this.hasErrorField('country') ? 'is-invalid form-control-danger' : '') }}
                    />
                </Form.Group>
                {!this.props.hidePhone && (
                    <Form.Group className={classnames('me-2', 'mb-2', this.hasErrorField('phone') ? 'has-danger' : '')}>
						<InputGroup className="mb-3">
							{(this.state.callingCode || this.state.address.phone) && (
								<DropdownButton
									variant="outline-dark"
									direction="up"
									title={this.state.callingCode && <span><Flag country={(this.state.countries.find(country => this.getCallingCodeFromCountry(country) === this.state.callingCode) || {}).cca2} /> +{this.state.callingCode}</span>}
								>
									{this.getAvailableCallingCodes(true).map(({ cca2, callingCode }) => (
										<Dropdown.Item key={`${cca2}-${callingCode}`} onClick={event => this.setState({ callingCode })}>
											<Flag country={cca2} /> +{callingCode}
										</Dropdown.Item>
									))}
								</DropdownButton>
							)}
							<Form.Control type="text" name="phone" onChange={this.handleChange} className={this.hasErrorField('phone') ? 'is-invalid form-control-danger' : ''} placeholder={this.props.intl.formatMessage({ id: 'addressPhone', defaultMessage: 'Phone (useful for delivery)' })} value={((this.state.address || {}).phone || '').replace(`+${this.state.callingCode}`, '')} />
						</InputGroup>
                    </Form.Group>
                )}

				{this.props.loggedUser?.role === 'admin' && (
					<Form.Group>
						<div className="d-flex justify-content-start">
							<Form.Label><FormattedMessage id="addressLegalInformation" defaultMessage="Legal informations" /></Form.Label>
							<Button variant="link" size="sm" className="p-0" onClick={this.handleAddLegal}><Icon icon="add" /></Button>
						</div>
						{(this.state.address.legal || []).map((legal, index) => (
							<Row key={index} className="gx-1">
								<Col>
									<Form.Control name="key" value={legal.key} onChange={event => this.handleChangeLegal(event, index)} />
								</Col>
								<Col>
									<Form.Control name="value" value={legal.value} onChange={event => this.handleChangeLegal(event, index)} />
								</Col>
								<Col xs="1">
									<Button variant="outline-danger" size="sm" onClick={() => this.handleRemoveLegal(index)}><Icon icon="trash" /></Button>
								</Col>
							</Row>
						))}
					</Form.Group>
				)}

                <div className="mt-2 text-end">
                    <ButtonGroup>
                        {!this.props.hideBackButton && <Button color="light" onClick={event => { event.preventDefault(); this.closeForm(''); }}><Icon icon="chevron-left" /> <FormattedMessage id="back" defaultMessage="Back" /></Button>}
                        <Button variant="outline-success" disabled={this.state.isSaving} onClick={this.handleSubmit}>
                            {
                                this.state.isSaving
                                ? <span><Icon icon="spinner" spin /> <FormattedMessage id="saving" defaultMessage="Saving..." /></span>
                                : <span><Icon icon="check-o" /> <FormattedMessage id="save" defaultMessage="Save" /></span>
                            }
                        </Button>
                    </ButtonGroup>
                </div>
            </Form>
        );
    }
}

// <Col>
//     <Form.Group>
//         <Label for="regionField"><FormattedMessage id="addressRegion" defaultMessage="Region" /></Label>
//         <Form.Control type="text" name="region" value={this.state.address.region} onChange={event => this.handleChange(event, true)} />
//     </Form.Group>
// </Col>

function mapStateToProps(store, props) {
	const loggedUser = getLoggedUser(store);
    return {
		loggedUser,
        user: props.user || loggedUser,
        addresses: store.addresses.data,
    };
}

AddressEditForm.defaultProps = {
    user: null,
    addresses: [],
    address: null,
    closeForm: null,
    displayLabel: false,
    hidePhone: false,
    hideBackButton: false,
    skipSave: false,
};

AddressEditForm.propTypes = {
    dispatch: PropTypes.func.isRequired,
	navigate: PropTypes.func.isRequired,
    intl: PropTypes.object.isRequired,
    user: PropTypes.object,
    addresses: PropTypes.array,
    address: PropTypes.object,
    displayLabel: PropTypes.bool,
    hidePhone: PropTypes.bool,
    closeForm: PropTypes.func,
    hideBackButton: PropTypes.bool,
    skipSave: PropTypes.bool,
};

export default connect(mapStateToProps)(injectIntl(withRouter(AddressEditForm)));
